"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YESNO = 'yesNo';
exports.RATING = 'rating';
exports.POLL = 'poll';
exports.LIKERT = 'likert';
exports.NPS = 'nps';
exports.TEXT = 'text';
exports.QUESTION_TYPES = [exports.YESNO, exports.RATING, exports.POLL, exports.LIKERT, exports.NPS, exports.TEXT];
